<template>
    <v-layout style='flex: 0 0 auto !important;' column>
        <v-card tile flat>
            <v-card-text class = 'pa-0'>
                <v-list subheader>
                    <user-project-create :project = 'project' :postAction = 'getProjectPersons' v-if = 'createAllowed'></user-project-create>
                    <v-divider v-if = '!indicator'></v-divider>
                    <v-progress-linear :color='$store.getters.uiAccent' class='mb-0 py-0 mt-0' height='1' :active='indicator' :indeterminate='true'></v-progress-linear>
                    <v-list-item list v-if = '!persons.length && !indicator'>
                        <v-list-item-content>
                            <v-list-item-title>Пользователи не подключены</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider v-if = '!persons.length && !indicator'></v-divider>
                    <v-list-group 
                      v-for = 'u in persons' 
                      :key = 'u.uid' 
                      no-action
                      style='border-bottom: 1px solid;border-color:#EEEEEE;'
                    >
                        <v-list-item slot="activator" class = 'px-0 mx-0'>
                            <v-list-item-content>
                                <v-list-item-title>{{u.name}} {{u.lastname}}</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <user-project-delete 
                                    :data = 'u' :project = 'project' :postAction = 'getProjectPersons' v-if = 'deleteAllowed'></user-project-delete>
                            </v-list-item-action>
                        </v-list-item>
                        <template>
                            <v-list-item class = 'pl-2'>
                                <v-list-item-title>{{u.mode_description}}</v-list-item-title>
                            </v-list-item>
                        </template>
                    </v-list-group>
                </v-list>
            </v-card-text>
        </v-card>
    </v-layout>
</template>

<script>

import UserProjectCreate from '@/components/entities/users/projects/CreateDialog.vue';
import UserProjectDelete from '@/components/entities/users/projects/DeleteDialog.vue';

import projectHandlers from '@/mixins/project'
import { orderBy } from 'lodash-es'

export default {
    name: 'ProjectPersons',
    props: ['data'],
    mixins: [projectHandlers],
    components: {
        'user-project-create': UserProjectCreate,
        'user-project-delete': UserProjectDelete
    },
    data() {
        return {
            visibility: {
                create: false,
                delete: false
            },
            project: this.data,
            persons: [],
            indicator: false
        }
    },
    computed: {
        createAllowed() {
            return ['X', 'U'].includes(this.project.mode_persons)
        },
        deleteAllowed() {
            return ['X', 'U'].includes(this.project.mode_persons)
        }
    },
    watch: {
        data(value) {
            this.project = value
            this.persons = []
            this.getProjectPersons()
        }
    },
    methods: {
        getProjectPersons() {
            this.indicator = true;
            this.getProjectPropertyPromise('persons').then((r) => {
                let response = r.body
                this.indicator = false
                if (response.result) {
                    this.persons = orderBy(response.data || [], ['lastname', 'name']);
                } else {
                    console.log('error fetch project persons', response.data)
                }
            });
        }
    },
    mounted() {
        this.getProjectPersons();
    }
}
</script>